import React from "react";
import Breadcrumb from "components/layout/breadcrumb/Breadcrumb";
import { useStyles } from "components/layout/CommonStyles";
import { useTranslation } from "react-i18next";

export default function ScholarshipsRecessesHistoryNavHeader({
  context,
  myRecesses,
}) {
  const classes = useStyles();
  const [t] = useTranslation();
  return (
    <div className="headerNewDesign">
      <Breadcrumb
        newDesign={true}
        routes={
          myRecesses
            ? [
                { label: t("HR.humanResource"), to: "/HumanResources" },
                { label: t("HR.recesses") },
                { label: t("HR.myRecesses") },
              ]
            : [
                { label: t("HR.humanResource"), to: "/HumanResources" },
                { label: t("HR.recesses") },
                {
                  label: t("HR.scholarshipRecessList"),
                  to: "/ScholarshipsRecesses",
                },
                {
                  label:
                    context === "edit"
                      ? t("GENERAL.manage") + " " + t("HR.scholarshipRecess")
                      : t("GENERAL.view") + " " + t("HR.scholarshipRecess"),
                },
              ]
        }
      />
      <div className="container-headerNewDesign">
        <h1 className={classes.titleNewDesign}>
          {myRecesses
            ? t("HR.myRecesses")
            : context === "edit"
            ? t("GENERAL.manage") + " " + t("HR.scholarshipRecess")
            : t("GENERAL.view") + " " + t("HR.scholarshipRecess")}
        </h1>
      </div>
    </div>
  );
}
